import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

/**
 * This componet is used to show error message on form field.
 * To use this component import FnInputModule in Module.
 */
@Component({
  selector: 'fn-input-error',
  templateUrl: 'fn-input-error.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FnInputErrorComponent implements OnInit {
  /**
   * Input member
   * used to show error after form is submitted .
   */
  @Input() submitted = false;
  /**
   * Input member
   * form control object used to check value of that field is valid or not.
   */
  @Input() control: any;
  /**
   * Input member
   * set the position of error message .
   */
  @Input() position = 'bottom';

  /**
   * Creates an instance of fn input error component.
   */
  constructor() {
  }
/**
  * Implements onInit event handler.
  */
  ngOnInit() {
  }

}
